import styled from 'styled-components'

export const ContentContainer = styled.div`
  width: 100%;
`
